import Rails from "@rails/ujs";
Rails.start();

// Javascript
import "src/public/load_stimulus_controllers";
